<template>
  <v-app-bar color="white" light height="92px">
    <div class="d-none d-lg-flex">
      <v-btn @click="emitChanges" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>
    <div class="d-flex d-lg-none hide-for-mobile">
      <v-btn @click="emitChangesSidebarForTab" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-col></v-col>
    </div>
    <div class="d-flex d-lg-none hide-for-tab">
      <v-btn @click="emitChangesSidebar" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-col></v-col>
    </div>
    <v-toolbar-title></v-toolbar-title>
    <v-spacer></v-spacer>

    <v-list class="hidden-md-and-up">
      <v-menu bottom origin="center center" transition="scale-transition" v-model="popup">
        <template v-slot:activator="{ on }">
          <v-btn color="#1c3d50" dark v-on="on">
            <v-icon dark>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list class="hidden-md-and-up">
          <v-list-item>
            <v-list-item-title>{{ this.$store.state.home.user.fullName }}</v-list-item-title>
          </v-list-item>
          <div class="my-2">
            <v-btn @click="logout" text large color="secondary">Log Out</v-btn>
          </div>
        </v-list>
      </v-menu>
    </v-list>

    <table class="hidden-sm-and-down text-left">
      <tbody class="subtitle-1">
      <tr>
        <td class="font-weight-bold">Name</td>
        <td class="pl-2">:</td>
        <td class="px-5">{{ $store.state.home.user.fullName }}</td>
      </tr>
      </tbody>
    </table>

    <v-btn @click="logout" color="secondary" class="mt-2 hidden-sm-and-down text-left" dark>Logout</v-btn>
  </v-app-bar>
</template>

<script>
import {EventBus} from '../../_helpers'
import {homeService} from '../../services'

export default {
  name: "DashboardCoreAppBar",
  data() {
    return {
      popup: false,
    }
  },
  methods: {
    emitChanges: function () {
      EventBus.$emit('Clicked')
    },
    emitChangesSidebar: function () {
      EventBus.$emit('Sidebar')
    },
    emitChangesSidebarForTab: function () {
      EventBus.$emit('SidebarForTab')
    },
    logout: function () {
      homeService.logout().then(
          this.$router.push('/')
      ).catch(function () {
        console.log("could not log out")
      })
    }
  },

  computed: {
    screenSize: function () {
      return this.$vuetify.breakpoint.name
    }
  },

  watch: {
    screenSize : function (newValue) {
      if(!(newValue==='xs'||newValue==='sm')) {
        this.popup=false
      }
    }
  }
}
</script>

<style scoped>
@media only screen and (min-width: 1000px) and (max-width: 1300px) {
  .hide-for-tab {
    display: none !important;
  }
}

@media only screen and (max-width: 999px) {
  .hide-for-mobile {
    display: none !important;
  }
}
</style>
